import { render, staticRenderFns } from "./MenuPage.vue?vue&type=template&id=6497b98e&"
import script from "./MenuPage.vue?vue&type=script&lang=js&"
export * from "./MenuPage.vue?vue&type=script&lang=js&"
import style0 from "./MenuPage.vue?vue&type=style&index=0&id=6497b98e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports